document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach(link => {
        link.addEventListener('click', function(event) {
            const targetID = this.getAttribute('href');
            const targetElement = document.querySelector(targetID);

            if (targetElement) {
                event.preventDefault();
                const headerHeight = document.querySelector('.header').offsetHeight; // Höhe der Kopfzeile abziehen
                const offset = 80; // Zusätzlicher Abstand in Pixeln
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - offset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth' // Smooth scroll
                });
            }
        });
    });
});
